import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import useAdminAuth from "../hooks/useAdminAuth";
import { ADMIN_SESSION_EVENT } from "../lib/axios";
import { ssoReset, startSso } from "../lib/sso";
import AdminAuthContext from "../contexts/AdminAuthContext";

const RELOAD_AT = "liquids_401_reload_at";
const shell = "admin-scope dark flex min-h-screen flex-col items-center justify-center gap-3 bg-background text-foreground";

export function SsoGate({ ssoStart, next }) {
  const [blocked, setBlocked] = useState(false);
  useEffect(() => { if (ssoStart && !startSso(ssoStart, next)) setBlocked(true); }, [ssoStart, next]);
  if (!ssoStart) {
    return (
      <div className={shell}>
        <p className="text-sm text-muted-foreground">서버에 연결하지 못했습니다.</p>
        <button className="rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground"
          onClick={() => window.location.reload()}>다시 시도</button>
      </div>
    );
  }
  if (!blocked) return <div className={shell}><p className="text-sm text-muted-foreground">포털 로그인으로 이동 중…</p></div>;
  return (
    <div className={shell}>
      <p className="text-sm text-muted-foreground">로그인을 확인하지 못했습니다.</p>
      <button className="rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground"
        onClick={() => { ssoReset(); startSso(ssoStart, next); }}>다시 로그인</button>
    </div>
  );
}

export default function AdminRoute({ children }) {
  const auth = useAdminAuth();
  const location = useLocation();
  const reloadedRef = useRef(false);

  useEffect(() => {
    // 401 만 다시 확인(→ 끊겼으면 SSO): 403 은 세션이 살아 있어 새로고침하면 무한 반복된다
    const onExpired = (e) => {
      if (e.detail?.status !== 401 || reloadedRef.current) return;
      try {
        if (Date.now() - Number(sessionStorage.getItem(RELOAD_AT) || 0) < 10000) return;
        sessionStorage.setItem(RELOAD_AT, String(Date.now()));
      } catch {}
      reloadedRef.current = true;
      window.location.reload();
    };
    window.addEventListener(ADMIN_SESSION_EVENT, onExpired);
    return () => window.removeEventListener(ADMIN_SESSION_EVENT, onExpired);
  }, []);

  if (auth.loading) return <div className={shell}><p className="text-sm text-muted-foreground">로그인 상태 확인 중…</p></div>;
  if (!auth.loggedIn) {
    if (auth.home) return <Navigate to={auth.home} replace />;
    return <SsoGate ssoStart={auth.ssoStart} next={location.pathname + location.search} />;
  }
  return (
    <AdminAuthContext.Provider value={{ role: auth.role, username: auth.displayName || auth.username, portalUrl: auth.portalUrl }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
